import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog';
import { TermsAndConditionsInfoComponent } from '../dialogs/terms-and-conditions-info/terms-and-conditions-info.component';
import { ActuarialAssumptionsInfoComponent } from '../dialogs/actuarial-assumptions-info/actuarial-assumptions-info.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(public dialog: MatDialog){

  }
  
  public viewTermsAndConditions(): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        title: 'Terms & Conditions',
        dialogContent: TermsAndConditionsInfoComponent,
      },
    });
  }

  public viewActuarialAssumptions(): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      autoFocus: false,
      disableClose: true,
      data: {
        title: 'Actuarial Assumptions',
        dialogContent: ActuarialAssumptionsInfoComponent,
      },
    });
  }
}
